import React from 'react'
import Header from '../../Header';
import Navbar from '../../Navbar';
import Footers from '../../Footers';
import './TrackYourOrder.css'


export default function TrackYourOrder() {
    return (
        <div>
            <Header />
            <Navbar />
            <div className='track'>
                <div className='track-heading'>
                    <h1 className='head-track'>Track Your Order</h1>
                </div>
            </div>

            <div className='input'>
                <h2 className='input-track'>
                    Enter Order ID:
                    <input type="id" className='input-track-order' placeholder='Order Number' />
                </h2>

            </div>
            <div className='input'>
                <h2 className='input-track'>
                    Phone Number:
                    <input type="id" className='input-track-order' placeholder='Phone Number' />
                </h2>
                <button type="button" className="TrackOrder">
                    Track Order
                </button>
            </div>












            <Footers />

        </div>
    )
}
